<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-documents"
        title="Fahrzeugversicherung"
        @save="saveLiabilityInsuranceFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Fahrzeugversicherung Kunde"/>
        </template>
        <b-row v-if="showChangelogButton">
            <div class="col d-flex justify-content-end">
                <csp-changelog-modal :changelog-url="changelogUrl"/>
            </div>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-show="shouldDisplayInsuranceParent"
                class="col-12"
                :form-context="formContext"
                label="Versicherungskonzern"
                :options-loader="loadInsuranceParentOptions"
                property="insuranceParent"
                type="autocomplete">
                <template v-slot:display-value>
                    <span v-if="formContext.data.insuranceName"><b>{{ formContext.data.insuranceName }}</b><br></span>
                    <span v-if="formContext.data.insurancePhone">{{ formContext.data.insurancePhone }}<br></span>
                    <span v-if="formContext.data.insuranceEmail">
                        <a :href="'mailto:' + formContext.data.insuranceEmail">
                            {{ formContext.data.insuranceEmail }}
                        </a>
                    </span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                v-show="shouldDisplayInsuranceBranch"
                class="col-12"
                :dependencies="['insuranceParent']"
                :form-context="formContext"
                label="Versicherungsfiliale"
                :options-loader="loadInsuranceBranchOptions"
                property="insuranceBranch"
                type="autocomplete">
                <template v-slot:display-value>
                    <span v-if="formContext.data.insuranceName"><b>{{ formContext.data.insuranceName }}</b><br></span>
                    <span v-if="formContext.data.insurancePhone">{{ formContext.data.insurancePhone }}<br></span>
                    <span v-if="formContext.data.insuranceEmail">
                        <a :href="'mailto:' + formContext.data.insuranceEmail">
                            {{ formContext.data.insuranceEmail }}
                        </a>
                    </span>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Meldung durch Autohaus"
                property="carDealerRecommendedInsurance"
                type="checkbox"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Vertragsnummer"
                property="insurancePolicyNr"
                type="text"/>
            <csp-desktop-info-card-element
                v-if="formContext.data.customerHasAdversaryInsuranceReference"
                class="col-6"
                :form-context="formContext"
                label="Schadennummer"
                property="adversaryInsuranceReference"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Teilkasko"
                property="isPartiallyComprehensive"
                type="radio"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Vollkasko"
                property="isFullyComprehensive"
                type="radio"/>
        </b-row>
        <b-row>
            <b-col cols="6">
                <csp-desktop-info-card-element
                    v-if="formContext.form.getProperty('isPartiallyComprehensive') === 'yes'"
                    :form-context="formContext"
                    label="Selbstbeteiligung Teilkasko"
                    property="partialCoverageCopayment"
                    type="currency"/>
            </b-col>
            <b-col cols="6">
                <csp-desktop-info-card-element
                    v-if="formContext.form.getProperty('isFullyComprehensive') === 'yes'"
                    :form-context="formContext"
                    label="Selbstbeteiligung Vollkasko"
                    property="comprehensiveCopayment"
                    type="currency"/>
            </b-col>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CustomerInsurancePolicy',
        mixins: [FormDataMixin],
        computed: {
            changelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/customer/insurances/liability/changelog';
            },
            shouldDisplayInsuranceBranch() {
                if (this.formContext?.isInEditMode) {
                    return true;
                }
                return !!this.formContext?.data['insuranceBranch'];
            },
            shouldDisplayInsuranceParent() {
                if (this.formContext?.isInEditMode) {
                    return true;
                }
                return !this.formContext?.data['insuranceBranch'];
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
        },
        methods: {
            loadInsuranceBranchOptions() {
                const parentId = this.formContext.form.getProperty('insuranceParent');
                return recordRepository.loadLegacySelectOptions(
                    'childInsurances',
                    {parentInsuranceId: parentId}
                );
            },
            loadInsuranceParentOptions() {
                return recordRepository.loadLegacySelectOptions('parentInsurances');
            },
            saveLiabilityInsuranceFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCustomerInsuranceLiability(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null).then(() => {
                });
            },
        },
    }
</script>
